import { FC } from "react";
import NodataIcon from "../assets/icons/face_id_error_icon 1.svg";

interface GrnErrorBoundaryInterface {
  message?: string;
}

export const GrnErrorBoundary: FC<GrnErrorBoundaryInterface> = ({
  message,
}) => {
  return (
    <div className="err-boundary-section">
      <div className="card">
        <img src={NodataIcon} alt="" />
        <div className="message">
          {message ||
            "A server could not find a client-requested web page. Please try again later"}
        </div>
      </div>
    </div>
  );
};
